import { Icon, IconProps } from "@chakra-ui/react";
import React from "react";

export function SiPowerBolt(props: IconProps): React.ReactElement {
  return (
    <Icon viewBox="0 0 21 20" fill="currentColor" {...props}>
      <path d="M13.4324 0L3 8.0579L9.7424 11.8969L6.93307 20L17.3655 11.9421L10.6231 8.10309L13.4324 0Z" />
    </Icon>
  );
}
